export default "__VITE_ASSET__CUzovJ1y__"